import * as $$Array from "bs-platform/lib/es6/array.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as Bolt0_res$Bolt0 from "bolt0/./bolt0_res.bs.js";
import * as Bolt0_list$Bolt0 from "bolt0/./bolt0_list.bs.js";
import * as Caml_builtin_exceptions from "bs-platform/lib/es6/caml_builtin_exceptions.js";

function Make(Record_param, Label) {
  var to_data = function to_data(l) {
    return (
      /* `List */
      [848054398, Bolt0_list$Bolt0.map(function (x) {
        return (
          /* `Float */
          [365180284, x]
        );
      }, l)]
    );
  };

  var of_data = function of_data(param) {
    if (typeof param === "number" || param[0] !== 848054398) {
      return (
        /* Invalid */
        144245463
      );
    } else {
      var match = Bolt0_res$Bolt0.all(Bolt0_list$Bolt0.map(function (param) {
        if (typeof param === "number") {
          return (
            /* `Error */
            [106380200,
            /* Invalid */
            144245463]
          );
        } else {
          var variant = param[0];

          if (variant !== 3654863 && variant !== 365180284) {
            return (
              /* `Error */
              [106380200,
              /* Invalid */
              144245463]
            );
          } else {
            return (
              /* `Ok */
              [17724, param[1]]
            );
          }
        }
      }, param[1]));

      if (match[0] >= 106380200) {
        return (
          /* Invalid */
          144245463
        );
      } else {
        return (
          /* `Ok */
          [17724, $$Array.of_list(match[1])]
        );
      }
    }
  };

  var Arg = {
    to_data: to_data,
    of_data: of_data
  };

  var size = Curry._1(Label.named_exn, "size");

  var last = Curry._1(Label.named_exn, "last");

  var max = Curry._1(Label.named_exn, "max");

  var min = Curry._1(Label.named_exn, "min");

  var sum = Curry._1(Label.named_exn, "sum");

  var range = Curry._1(Label.named_exn, "range");

  var mean = Curry._1(Label.named_exn, "mean");

  var $$var = Curry._1(Label.named_exn, "var");

  var std = Curry._1(Label.named_exn, "std");

  var median = Curry._1(Label.named_exn, "median");

  var first_quartile = Curry._1(Label.named_exn, "first_quartile");

  var third_quartile = Curry._1(Label.named_exn, "third_quartile");

  var trimmed_max = Curry._1(Label.named_exn, "trimmed_max");

  var trimmed_min = Curry._1(Label.named_exn, "trimmed_min");

  var outliers = Curry._1(Label.named_exn, "outliers");

  var Label$1 = {
    size: size,
    last: last,
    max: max,
    min: min,
    sum: sum,
    range: range,
    mean: mean,
    $$var: $$var,
    std: std,
    median: median,
    first_quartile: first_quartile,
    third_quartile: third_quartile,
    trimmed_max: trimmed_max,
    trimmed_min: trimmed_min,
    outliers: outliers
  };
  var Const = {
    Label: Label$1
  };
  var $$Error = {};

  var to_record = function to_record(size$1, last$1, max$1, min$1, sum$1, range$1, mean$1, $$var$1, std$1, median$1, first_quartile$1, third_quartile$1, trimmed_max$1, trimmed_min$1, outliers$1) {
    var match = Curry._1(Record_param.R.of_alist,
    /* :: */
    [
    /* tuple */
    [size,
    /* `Int */
    [3654863, size$1]],
    /* :: */
    [
    /* tuple */
    [last,
    /* `Float */
    [365180284, last$1]],
    /* :: */
    [
    /* tuple */
    [max,
    /* `Float */
    [365180284, max$1]],
    /* :: */
    [
    /* tuple */
    [min,
    /* `Float */
    [365180284, min$1]],
    /* :: */
    [
    /* tuple */
    [sum,
    /* `Float */
    [365180284, sum$1]],
    /* :: */
    [
    /* tuple */
    [range,
    /* `Float */
    [365180284, range$1]],
    /* :: */
    [
    /* tuple */
    [mean,
    /* `Float */
    [365180284, mean$1]],
    /* :: */
    [
    /* tuple */
    [$$var,
    /* `Float */
    [365180284, $$var$1]],
    /* :: */
    [
    /* tuple */
    [std,
    /* `Float */
    [365180284, std$1]],
    /* :: */
    [
    /* tuple */
    [median,
    /* `Float */
    [365180284, median$1]],
    /* :: */
    [
    /* tuple */
    [first_quartile,
    /* `Float */
    [365180284, first_quartile$1]],
    /* :: */
    [
    /* tuple */
    [third_quartile,
    /* `Float */
    [365180284, third_quartile$1]],
    /* :: */
    [
    /* tuple */
    [trimmed_max,
    /* `Float */
    [365180284, trimmed_max$1]],
    /* :: */
    [
    /* tuple */
    [trimmed_min,
    /* `Float */
    [365180284, trimmed_min$1]],
    /* :: */
    [
    /* tuple */
    [outliers,
    /* `List */
    [848054398, Bolt0_list$Bolt0.map(function (f) {
      return (
        /* `Float */
        [365180284, f]
      );
    }, outliers$1)]],
    /* [] */
    0]]]]]]]]]]]]]]]);

    if (match[0] >= 17724) {
      return match[1];
    } else {
      throw [Caml_builtin_exceptions.assert_failure,
      /* tuple */
      ["stats.ml", 165, 28]];
    }
  };

  var size$1 = Curry._2(Record_param.flag1, size, Curry._1(Record_param.Flag.required, Record_param.Arg_type.$$int));

  var last$1 = Curry._2(Record_param.flag1, last, Curry._1(Record_param.Flag.required, Record_param.Arg_type.$$float));

  var max$1 = Curry._2(Record_param.flag1, max, Curry._1(Record_param.Flag.required, Record_param.Arg_type.$$float));

  var min$1 = Curry._2(Record_param.flag1, min, Curry._1(Record_param.Flag.required, Record_param.Arg_type.$$float));

  var sum$1 = Curry._2(Record_param.flag1, sum, Curry._1(Record_param.Flag.required, Record_param.Arg_type.$$float));

  var range$1 = Curry._2(Record_param.flag1, sum, Curry._1(Record_param.Flag.required, Record_param.Arg_type.$$float));

  var mean$1 = Curry._2(Record_param.flag1, mean, Curry._1(Record_param.Flag.required, Record_param.Arg_type.$$float));

  var $$var$1 = Curry._2(Record_param.flag1, $$var, Curry._1(Record_param.Flag.required, Record_param.Arg_type.$$float));

  var std$1 = Curry._2(Record_param.flag1, std, Curry._1(Record_param.Flag.required, Record_param.Arg_type.$$float));

  var median$1 = Curry._2(Record_param.flag1, median, Curry._1(Record_param.Flag.required, Record_param.Arg_type.$$float));

  var first_quartile$1 = Curry._2(Record_param.flag1, first_quartile, Curry._1(Record_param.Flag.required, Record_param.Arg_type.$$float));

  var third_quartile$1 = Curry._2(Record_param.flag1, third_quartile, Curry._1(Record_param.Flag.required, Record_param.Arg_type.$$float));

  var trimmed_max$1 = Curry._2(Record_param.flag1, trimmed_max, Curry._1(Record_param.Flag.required, Record_param.Arg_type.$$float));

  var trimmed_min$1 = Curry._2(Record_param.flag1, trimmed_min, Curry._1(Record_param.Flag.required, Record_param.Arg_type.$$float));

  var outliers$1 = Curry._2(Record_param.flag1, outliers, Curry._1(Record_param.Flag.required, Curry._1(Record_param.Arg_type.list, Record_param.Arg_type.$$float)));

  var Param = {
    size: size$1,
    last: last$1,
    max: max$1,
    min: min$1,
    sum: sum$1,
    range: range$1,
    mean: mean$1,
    $$var: $$var$1,
    std: std$1,
    median: median$1,
    first_quartile: first_quartile$1,
    third_quartile: third_quartile$1,
    trimmed_max: trimmed_max$1,
    trimmed_min: trimmed_min$1,
    outliers: outliers$1
  };

  var of_record = function of_record(record, f) {
    var make = f;

    var param = Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._1(Record_param.$$return, make), Curry._1(Record_param.errs, size$1)), Curry._1(Record_param.errs, last$1)), Curry._1(Record_param.errs, max$1)), Curry._1(Record_param.errs, min$1)), Curry._1(Record_param.errs, sum$1)), Curry._1(Record_param.errs, range$1)), Curry._1(Record_param.errs, mean$1)), Curry._1(Record_param.errs, $$var$1)), Curry._1(Record_param.errs, std$1)), Curry._1(Record_param.errs, median$1)), Curry._1(Record_param.errs, first_quartile$1)), Curry._1(Record_param.errs, third_quartile$1)), Curry._1(Record_param.errs, trimmed_max$1)), Curry._1(Record_param.errs, trimmed_min$1)), Curry._1(Record_param.errs, outliers$1));

    return Curry._2(Record_param.parse, record, param);
  };

  var T = {
    Const: Const,
    $$Error: $$Error,
    to_record: to_record,
    Param: Param,
    of_record: of_record
  };
  return {
    Record_param: Record_param,
    Label: Label,
    Arg: Arg,
    T: T
  };
}

export { Make };
/* No side effect */